import { ColumnDef } from "@tanstack/react-table";
import { formatDate } from "@/core/utils/date";

type DateRow = {
  external_created_at: string | null;
  created_at: string;
};

export const DateCol = <T extends DateRow = DateRow>(): ColumnDef<T> => ({
  header: "Date",
  accessorKey: "external_created_at",
  sortingFn: "datetime",
  cell: ({ row }) => {
    const dateStr = row.original.external_created_at || row.original.created_at;
    return formatDate(dateStr);
  },
});
